import React, { useState, useEffect, useRef } from "react";
import { reservationsActions, locationActions, useSelector } from "inbooma-api";
import { Biscuit, Notification } from "../../../utils";
import Rbac from "../../../utils/Rbac";
import t from "../../helpers/t";
import { FormatHelper } from "../../../utils";
import { getContentModifications } from "../../../App";
import { _, moment, Radio } from "../../../../vendor";
import GoogleMap from "./components/GoogleMap";
import ReservationListView from "./components/ReservationListView";
import ResourceListView from "./components/ResourceListView";
import WidgetCheckins from "./components/WidgetCheckins";
import WidgetAvailables from "./components/WidgetAvailables";
import WidgetUsers from "./components/WidgetUsers";
import LocationInfoOverlay from "./components/LocationInfoOverlay";
import DatePicker from "react-datepicker";
import StatisticsLite from "./components/StatisticsLite";
import NewMapOverlay from "../../components/NewMapOverlay";
import {getEnv} from "../../../Sync";

export const rbac = new Rbac({
  _rbac: {
    admin: {
      write: true,
      delete: true,
      widgetUsers: true,
      widgetAvailables: true,
      readAll: true,
    },
    manager: {
      write: true,
      delete: true,
      widgetUsers: true,
      widgetAvailables: true,
      readAll: true,
    },
    "booking-manager": {
      write: true,
      delete: true,
      widgetUsers: true,
      widgetAvailables: true,
      readAll: true,
    },
    "manager-location": {
      write: true,
      delete: true,
      widgetUsers: true,
      widgetAvailables: true,
      readAll: true,
    },
    "garage-staff": {
      write: true,
      delete: false,
      widgetUsers: true,
      widgetAvailables: true,
      readAll: false,
    },
    guide: {
      write: false,
      delete: false,
      widgetUsers: true,
      widgetAvailables: true,
      readAll: false,
    },
    user: {
      write: false,
      delete: false,
      widgetUsers: false,
      widgetAvailables: false,
      readAll: false,
    },
  },
});

export const DashboardPage = (props) => {
  // mark main menu
  let mainMenu = document.getElementById("inb-main-menu");
  if (
    mainMenu !== undefined &&
    mainMenu != null &&
    mainMenu.querySelector(".l-dashboard")
  ) {
    if (mainMenu.querySelector(".active") != null)
      mainMenu.querySelector(".active").classList.remove("active");
    mainMenu.querySelector(".l-dashboard").classList.add("active");
  }
  let language = Biscuit.get("user.lang").replace("_", "-");

  const [dashboardSettings, setDashboardSettings] = useState({
    widgetCheckins: { isVisible: true, position: 0 },
    widgetAvailables: { isVisible: true, position: 1 },
    widgetUsers: { isVisible: true, position: 2 },
    widgetReservations: { isVisible: true, position: 0 },
    widgetResources: { isVisible: false, position: 1 },
  });
  const [minTopSpaceForListView, setMinTopSpaceForListView] = useState(0);

  // map stuff
  const [mapStatus, setMapStatus] = useState(2);
  const [markers, setMarkers] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    latitude: 51.3386,
    longitude: 12.3766,
  });
  const [mapMarker, setMapMarker] = useState({
    url: "",
    width: 0,
    height: 0,
    scaleDown: false,
    ready: false,
  });

  const [mapBounds, setMapBounds] = useState(null);
  const [mapReference, setMapReference] = useState(null);
  const [mapApiReference, setMapApiReference] = useState(null);
  const _location = useSelector((state) => state.locations_data.location);
  const [locationInfo, setLocationInfo] = useState("");
  const [markersAvailables, setMarkersAvailables] = useState([]);

  const clientToken = Biscuit.get("token");

  // reservations stuff
  const [initialized, setInitialized] = useState(false);
  const [reservationsPending, setReservationsPending] = useState(false);
  const [locationsPending, setLocationsPending] = useState(false);
  const [reservations, setReservations] = useState([]);
  const [locations, setLocations] = useState([]);
  const _reservations = useSelector(
    (state) => state.reservations.getReservations
  );
  const _reservation = useSelector(
    (state) => state.reservations.patchReservations
  );
  const _locations = useSelector((state) => state.locations_data.locations);

  useEffect(() => {
    if (_reservations.success == "") return;

    if (_reservations.success === true && reservationsPending) {
      setReservations([..._reservations.data]);
      setReservationsPending(false);
    } else {
      console.log("Failed to request reservations!");
    }
  }, [_reservations]);

  useEffect(() => {
    if (_reservation.success == "") return;

    if (_reservation.success === true) {
      // find reservation with matching id
      var clone = [...reservations];
      for (var i = 0; i < reservations.length; i++) {
        if (reservations[i].id == _reservation.data.id) {
          clone[i].status = _reservation.data.status; // this is the only value which can be changed through reservation list
          setReservations(clone);
          return;
        }
      }
    } else {
      console.log("Failed to patch reservation!");
    }
  }, [_reservation]);

  useEffect(() => {
    if (_locations.success == "") {
      console.log("Locations: state unknown");
      return;
    }

    if (_locations.success === true) {
      createMarkerFromLocations(_locations.data);
      setLocations([..._locations.data]);
      setLocationsPending(false);
    } else {
      console.log("Failed to request locations!");
    }
  }, [_locations]);

  /**
   * Return amount of available resources for today
   *
   * @return {object} see below
   */
  const getNumbersByToday = (contingent) => {
    return getNumbersByDay(
      moment().hours(0).minutes(0).seconds(0).milliseconds(0),
      contingent
    );
  };

  /**
   * Return amount of available resources on a specific day
   *
   * @param {String|Moment} day
   * @return {object} w/ attributes id, contingent_id, number, valid_from
   */
  const getNumbersByDay = (day, contingent) => {
    if (typeof day === "string") {
      day = moment(day);
    }

    let result;

    _.each(contingent.contingent_numbers, function (numberObj, __) {
      const valid_from = moment(numberObj.valid_from);

      if (valid_from.isSameOrBefore(day)) {
        if (typeof result !== "undefined") {
          // Compare with previous valid_from
          if (moment(result.valid_from).isAfter(valid_from)) {
            return;
          }
        }

        result = numberObj;
      }
    });

    return result;
  };

  const createMarkerInfoFromLocation = (data) => {
    const user_role = Biscuit.get("user.role");
    var tpl =
      '<div class="locationItemPopup">' +
      "<h4>" +
      data.name +
      "</h4>" +
      '<p class="description">' +
      (data.description == null ? "" : data.description) +
      "</p>" +
      '<ul class="inb-vert-list">';

    if (data.contingents.length > 0) {
      tpl +=
        '<span class="inb-list-title">' +
        t("contingents", null, "capital") +
        "</span>";
      _.each(
        _.sortBy(data.contingents, function (model) {
          return model.name;
        }),
        function (cont, key) {
          var number_active = getNumbersByToday(cont);
          var result = '<li><a href="/contingents/' + cont.id + '/edit">';
          result +=
            cont.name + " " + FormatHelper.formatContingentTags(cont.tags);
          if (number_active)
            result +=
              " (" + number_active.number + " " + t("vehicles_active") + ")";
          result += "</a></li>";
          tpl += result;
        }
      );
    } else {
      tpl += "<li>" + t("no_contingents_yet") + "</li>";
    }
    tpl += "</ul>";

    if (user_role === "admin") {
      tpl +=
        "<hr />" +
        "<a " +
        'href="/locations/' +
        data.id +
        '"' +
        'class="location__edit">' +
        t("edit", null, "capital") +
        "</a>" +
        "|" +
        "<a " +
        'href="/locations/' +
        data.id +
        '?action=delete" ' +
        'class="location__remove">' +
        t("remove", null, "capital") +
        "</a>" +
        "|";
    }

    if (
      user_role === "admin" ||
      user_role === "manager" ||
      user_role === "manager_location"
    ) {
      tpl +=
        "<a " +
        'href="/check_in_periods?location_id=' +
        data.id +
        '" ' +
        'title="' +
        t("edit_${a}", { a: t("opening_times") }) +
        '" ' +
        'class="location__opening_times">' +
        t("opening_times", null, "capital") +
        "</a>";
    }
    tpl += "</div>";

    return tpl;
  };

  const clientId = Biscuit.get("user.client_id");
  const createMarkerFromLocations = (locations) => {
    const clientProduct = Biscuit.get("client.product");

    let markerImage = Biscuit.get("client.marker");

    if (
      typeof markerImage === "undefined" ||
      markerImage === "" ||
      markerImage === null
    ) {
      if (
        typeof clientProduct !== "undefined" &&
        clientProduct == "inbooma.net Booking Software"
      ) {
        // Default client
        markerImage = "assets/img/default-map-marker.png";
      } else {
        // Bikesharing client
        markerImage = "assets/img/default-map-marker-bikesharing.png";
      }
    }

    // This should only be a temporary solution
    // Actual "problem": On initial page load, LocationsView becomes called too early so client
    // logo & marker is not set yet. Solution: Defer rendering, e.g. via dedicated Radio-event called from App.js
    // or (too be developed) via InboomaBaseView (e.g. this.dependencies = { models: { type: 'client', id: Biscuit.get('user.client_id') } })
    if (Number(Biscuit.get("user.client_id")) === 7) {
      markerImage =
        "https://s3.eu-central-1.amazonaws.com/inbooma/images/rab_mapmarker.png";
    }

    if (Number(Biscuit.get("user.client_id")) === 11) {
      markerImage = "assets/img/default-map-marker-bikesharing.png";
    }

    let _markers = [];
    for (var i = 0; i < locations.length; i++) {
      _markers.push({
        id: locations[i].id,
        longitude: locations[i].longitude,
        latitude: locations[i].latitude,
        title: locations[i].name,
        draggable: false,
        imageUrl:
          locations[i].location_marker !== null &&
          locations[i].location_marker !== ""
            ? locations[i].location_marker
            : markerImage,
        imageSize: {
          width: mapMarker.width === 0 ? 80 : mapMarker.width,
          height: mapMarker.height === 0 ? 100 : mapMarker.height,
        },
        imageDownScale: mapMarker.scaleDown,
      });
    }
    setMarkers(_markers);
  };

  const getMarkerInfo = (index) => {
    if (markers.length > index) {
      for (var i = 0; i < locations.length; i++) {
        if (locations[i].id == markers[index].id) {
          props.dispatch(
            locationActions.getLocation({
              token: Biscuit.get("token"),
              id: markers[index].id,
              parameters: {
                headers: {
                  "Accept-Language": language,
                  "Content-Language": language,
                },
              },
            })
          );
          return null;
        }
      }
    }
    return null;
  };

  // remove marker info again (on close)
  const removeMarkerInfo = (index) => {
    if (
      markers.length > index &&
      typeof markers[index].info !== "undefined" &&
      markers[index].info != null
    ) {
      var clone = [...markers];
      clone[index].info = null;
      setMarkers(clone);

      console.log("SHOW");
      showWidgets();
    }
  };

  const getMinTopSpaceForListView = (settings) => {
    let widgetCount = 0;
    if (settings.widgetCheckins.isVisible) widgetCount++;
    if (
      settings.widgetAvailables.isVisible &&
      rbac.hasPermission("widgetAvailables") &&
      Biscuit.get("client.hasResources") === "true"
    )
      widgetCount++;
    if (settings.widgetUsers.isVisible && rbac.hasPermission("widgetUsers"))
      widgetCount++;
    setMinTopSpaceForListView(widgetCount * 100 + 30); // number of micro widgets times height plus margin
  };

  const hideWidgets = () => {
    if (document.body.scrollWidth >= 768) return;

    let microWidgets = document.getElementsByClassName("inb-widget-small");
    let macroWidgets = document.getElementsByClassName("inb-widget");

    for (var i = 0; i < microWidgets.length; i++) {
      microWidgets[i].classList.add("hide");
    }

    for (var j = 0; j < macroWidgets.length; j++) {
      macroWidgets[j].classList.add("hide");
    }
  };

  const showWidgets = () => {
    if (document.body.scrollWidth >= 768) return;

    let microWidgets = document.getElementsByClassName("inb-widget-small");
    let macroWidgets = document.getElementsByClassName("inb-widget");

    for (var i = 0; i < microWidgets.length; i++) {
      microWidgets[i].classList.remove("hide");
    }

    for (var j = 0; j < macroWidgets.length; j++) {
      macroWidgets[j].classList.remove("hide");
    }
  };

  const onMapInitializedHandle = (map, api) => {
    console.log("map init handle:", map);

    setMapReference(map);
    setMapApiReference(api);
  };

  const initialize = () => {
    if (initialized === true) return;

    // check if content modifications have been loaded
    if (!getContentModifications().isReady) {
      setTimeout(() => {
        initialize();
      }, 300);
      return;
    }

    // initialize dashboard settings
    const settings = getContentModifications().dashboard;
    var clone = { ...dashboardSettings };
    if (typeof settings !== "undefined" && settings != null) {
      // set micro widgets settings
      // deactivate micro widgets
      clone.widgetCheckins.isVisible = false;
      clone.widgetAvailables.isVisible = false;
      clone.widgetUsers.isVisible = false;
      if (
        typeof settings.micro_widgets !== "undefined" &&
        settings.micro_widgets != null &&
        settings.micro_widgets.length > 0
      ) {
        // set micro widgets
        for (var i = 0; i < settings.micro_widgets.length; i++) {
          clone[settings.micro_widgets[i]].isVisible = true;
          clone[settings.micro_widgets[i]].position = i;
        }
      }
      // set macro widget settings
      // deactivate macro widgets
      clone.widgetReservations.isVisible = false;
      clone.widgetResources.isVisible = false;
      if (
        typeof settings.macro_widgets !== "undefined" &&
        settings.macro_widgets != null &&
        settings.macro_widgets.length > 0
      ) {
        // set macro widgets
        for (var i = 0; i < settings.macro_widgets.length; i++) {
          clone[settings.macro_widgets[i]].isVisible = true;
          clone[settings.macro_widgets[i]].position = i;
        }
      }
    }

    if (
      clone.widgetReservations.isVisible === true &&
      reservationsPending === false
    ) {
      props.dispatch(
        reservationsActions.getReservations({
          token: Biscuit.get("token"),
          suffix: "",
          filter: {
            find: "full",
            sort: "begin",
            direction: "asc",
            begin_gte: moment().format("YYYY-MM-DD"),
            finder: "NotCancelled",
            limit: 40,
            page: 1,
          },
        })
      );
      setReservationsPending(true);
    }
    if (
      clone.widgetReservations.isVisible === true &&
      locationsPending === false
    ) {
      props.dispatch(
        locationActions.getLocations({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            find: "short",
            limit: 999,
            page: 1,
          },
          parameters: {
            headers: {
              "Accept-Language": Biscuit.get("user.lang").replace("_", "-"),
            },
          },
        })
      );
      setLocationsPending(true);
    }
    setDashboardSettings(clone);
    getMinTopSpaceForListView(clone);

    // get availables for locations

    setInitialized(true);
  };

  initialize();
  // console.log("MAP REF IND: ", typeof mapReference !== 'undefined' && mapReference !== null && typeof mapReference.getBounds === 'function' ? mapReference.getBounds() : 'no valid map');

  const enableChart = clientId === "49";
  const [clientHash, setClientHash] = useState("");

  useEffect(() => {
    const hash = Biscuit.get("client.hash");
    console.log("Fetched hash: ", hash);
      setClientHash(hash);
    const availability = true;
  }, []);

  return (
    <>
      <div id="inb-c-main-dashboard">
        {getEnv() !== 'prod' && <NewMapOverlay
          locations={_locations}
          clientHash={Biscuit.get("client.hash")}
          clientToken={Biscuit.get("client.token")}
          availability={false}
          clientID={Biscuit.get("client.id")}
          language={language}
        />}
        <GoogleMap
          hasOverlay={false}
          hasHeader={false}
          hasFoooter={false}
          hasFixedPosition={true}
          containerSize={{ width: "99%", height: "87.5%" }}
          containerMargin={{ left: "0.5%", top: "80px" }}
          containerColor={"white"}
          markers={markers}
          zoomLevel={9}
          defaultCenter={mapCenter}
          //center={mapCenter}    // if not set: center is set by markers bounding
          status={mapStatus}
          setMapBounds={setMapBounds}
          onClickMarkerHandler={getMarkerInfo}
          removeMarkerInfo={removeMarkerInfo}
          onMapInitialized={onMapInitializedHandle}
        />

        {dashboardSettings.widgetCheckins.isVisible &&
          initialized &&
          !reservationsPending && (
            <WidgetCheckins
              dispatch={props.dispatch}
              position={dashboardSettings.widgetCheckins.position}
            />
          )}
        {dashboardSettings.widgetAvailables.isVisible &&
          rbac.hasPermission("widgetAvailables") &&
          Biscuit.get("client.hasResources") === "true" && (
            <WidgetAvailables
              dispatch={props.dispatch}
              position={dashboardSettings.widgetAvailables.position}
            />
          )}
        {dashboardSettings.widgetUsers.isVisible &&
          rbac.hasPermission("widgetUsers") && (
            <WidgetUsers
              dispatch={props.dispatch}
              position={
                rbac.hasPermission("widgetAvailables") &&
                Biscuit.get("client.hasResources") === "true"
                  ? dashboardSettings.widgetUsers.position
                  : dashboardSettings.widgetAvailables.position
              }
            />
          )}
        {dashboardSettings.widgetReservations.isVisible && !enableChart && (
          <ReservationListView
            dispatch={props.dispatch}
            minTopMargin={minTopSpaceForListView}
            locations={_locations}
            reservations={reservations}
          />
        )}
        {enableChart && (
          <div
            id="inb-c-main-dashboard-orders"
            className="inb-widget inb-float-sidebar inb-float-sidebar--right large"
            style={{
              height: "33vh",
              overflow: "auto",
            }}
          >
            <StatisticsLite client_id={Biscuit.get("user.client_id")} />
          </div>
        )}

        {dashboardSettings.widgetResources.isVisible && (
          <ResourceListView
            dispatch={props.dispatch}
            locations={_locations}
            resources={resources}
          />
        )}
        {document.location.href.indexOf("showDashboardCanvas=true") >= 0 && (
          <LocationInfoOverlay
            map={mapReference}
            api={mapApiReference}
            mapContainerId={"inb-google-map"}
            markers={markers}
            markersData={markersAvailables}
          />
        )}
      </div>
    </>
  );
};
